import _Empty from './Empty';

import './style/index.js';

export type { EmptyProps } from './Empty';
export * from './type';

export const Empty = _Empty;
export default Empty;
